import { render, staticRenderFns } from "./LernerFeatured.vue?vue&type=template&id=7bbf4c3a&scoped=true&"
import script from "./LernerFeatured.vue?vue&type=script&lang=js&"
export * from "./LernerFeatured.vue?vue&type=script&lang=js&"
import style0 from "./LernerFeatured.vue?vue&type=style&index=0&id=7bbf4c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf4c3a",
  null
  
)

export default component.exports